import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import Button from "../../../../components/UiKit/Button/Button";
import stl from "./FavoriteNoResult.module.css";
import useHelpers from "@hooks/useHelpers";
var FavoriteNoResult = function FavoriteNoResult() {
  var _useTranslation = useTranslation(["web_favorite"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.mainContainer
  }, /*#__PURE__*/React.createElement("img", {
    width: "115px",
    src: CDN_LINK + "/assets/images/fav _empty _state.svg",
    alt: "No favorites illustration"
  }), /*#__PURE__*/React.createElement("h2", null, t("favorite_cars_2", {
    ns: "web_favorite"
  })), /*#__PURE__*/React.createElement("p", null, t("add_cars_favorites_reach_easily", {
    ns: "web_favorite"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.button
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    onClick: function onClick() {
      return navigateTo("/filters");
    },
    className: ["blueBtn", stl.blueButtonDesign].join(" ")
  }, t("start_searching", {
    ns: "web_favorite"
  }))));
};
export default FavoriteNoResult;